export const ANALYTICS_ID = "G-EEP9599659"

// Give gtag enough time to process a lead before the thank-you-page redirect,
// while keeping the successful form submission responsive if Google is blocked.
export const ANALYTICS_EVENT_TIMEOUT_MS = 1000
